import { Competency } from '../../../../../adl-gen/totalinteraction/futurefit/db';
import { ListEntry } from '../../../common/list/list-types';
import { ListFieldInfo } from '../../../common/list/list-types';

export type CompetencyListEntry = ListEntry<Competency>;

export const CompetencyListView: ListFieldInfo<CompetencyListEntry, undefined>[] = [
  {
    name: 'name',
    label: 'Name',
    kind: 'i18nTextLink',
    displayed: true,
    sortable: true,
    searchable: true
  },
  {
    name: 'definition',
    label: 'Definition',
    kind: 'i18nText',
    displayed: true,
    sortable: true
  },
  {
    name: 'ordering',
    label: 'Ordering',
    kind: 'text',
    displayed: true,
    sortable: true
  }
];

export const TestCompetencyListView: ListFieldInfo<CompetencyListEntry, undefined>[] = [
  {
    name: 'name',
    label: 'Name',
    kind: 'i18nTextLink',
    displayed: true,
    sortable: true,
  },
  {
    name: 'definition',
    label: 'Definition',
    kind: 'i18nText',
    displayed: true,
    sortable: true
  },
  {
    name: 'ordering',
    label: 'Ordering',
    kind: 'text',
    displayed: true,
    sortable: true
  }
];



// WEBPACK FOOTER //
// ./src/admin/ui/components/lists/competency-list/competency-list-view.ts